import React, { useState, useEffect } from "react";
import MaskedInput from "react-text-mask";
import {
  Form,
  Col,
  Button,
  FormText,
  Container,
  Row,
  Image,
  NavDropdown,
} from "react-bootstrap";
import Alert from "../common/Alert";
import UploadPicturePopup from "./UploadPicturePopup";
import RemovePicturePopup from "./RemovePicturePopup";
import {
  ENTER_REQUIRED_INFO,
  UNIQUE_ENTITY_NAME,
  ZIP_CODE_INVALID,
  PROFILE_UPDATED_SUCCESSFULLY,
  ERROR_WHILE_UPDATING_PROFILE,
  ENTER_MOBILE_NUMBER,
  SELECT_STATE,
  ENTER_ZIP_CODE,
  INVALID_ZIP_CODE,
  ADD_LEGAL_ENTITIES_WITH_ACCOUNTS,
  ERROR_LOADING_USER_PROFILE,
  ENTER_FIRST_NAME,
  ENTER_ONLY_LETTERS,
  ENTER_LAST_NAME,
  ENTER_MAIL,
  EMAIL_IS_INVALID,
  ENTER_MAILING_ADDRESS,
  INVALID_MAILING_ADDRESS,
  ENTER_CITY,
  INVALID_CITY,
  ENTER_ENTITY_NAME,
  INVALID_ENTITY_NAME,
  SELECT_ATLEAST_ONE_PROVIDER,
} from "../../configurations/MessageConstants";
import {
  DANGER,
  ELECTRIC_PROVIDERS_LIST,
  EMPTY,
  INFO,
  STATES,
} from "../../configurations/Constants";
import UserService from "../../api-service/UserService";
import LoadingOverlay from "../common/LoadingOverlay";
import { useSelector, useDispatch } from "react-redux";

function UserProfile() {
  const [user, setUser] = useState({
    firstName: EMPTY,
    lastName: EMPTY,
    email: EMPTY,
    phoneNumber: EMPTY,
    address: EMPTY,
    city: EMPTY,
    state: EMPTY,
    zipCode: EMPTY,
    signUpCode: EMPTY,
    userId: EMPTY,
  });
  const userInfo = useSelector((state) => state.user.userInfo);
  const [validated, setValidated] = useState(false);
  const [legalEntities, setLegalEntities] = useState([{ name: EMPTY }]);
  const [allPowerProviderChecked, setAllPowerProviderChecked] = useState(false);
  const [powerProviders, setPowerProviders] = useState(ELECTRIC_PROVIDERS_LIST);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [zipCodeError, setZipCodeError] = useState(false);
  const [variant, setVariant] = useState(DANGER);
  const [legalEntitiesError, setLegalEntitiesError] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showProfilePicturePopup, setShowProfilePicturePopup] = useState(false);
  const [showRemovePicturePopup, setShowRemovePicturePopup] = useState(false);

  const handleOnChange = (e, prevState) => {
    let name = e.target.name;
    let value = e.target.value;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const loadProfileData = async () => {
    setOverlayLoading(true);
    try {
      const response = await UserService.getProfileInfo();
      let userProfileData = await response.data;
      let activePowerProviders = 0;
      let entities = [];
      userProfileData.data.legal_entities.forEach((entity) => {
        entities.push({ name: entity });
      });
      powerProviders.forEach((p) => {
        if (userProfileData.data.electric_power_provider[p.name]) {
          activePowerProviders += 1;
        }
        p.isActive = userProfileData.data.electric_power_provider[p.name];
      });

      setUser({
        firstName: userProfileData.data.first_name,
        lastName: userProfileData.data.last_name,
        email: userProfileData.data.email,
        phoneNumber: userProfileData.data.phone,
        address: userProfileData.data.address,
        city: userProfileData.data.city,
        state: userProfileData.data.state,
        zipCode: userProfileData.data.postal_code,
        noPowerProviders: activePowerProviders > 0 ? true : false,
      });
      setLegalEntities(entities);
      setOverlayLoading(false);
    } catch (error) {
      setOverlayLoading(false);
      handleAlert(error.message, DANGER);
      console.error(ERROR_LOADING_USER_PROFILE, error);
    }
  };

  const handleEditUserProfile = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsEditable(true);
  };

  const handleCancelUserProfile = () => {
    loadProfileData();
    setIsEditable(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
    closeAlert();
  };

  useEffect(() => {
    loadProfileData();
    if (document.getElementById("jsd-widget")) {
      document.getElementById("jsd-widget").style.opacity = "100";
    }
  }, []);

  const handleAddLegalEntities = () => {
    setLegalEntities(legalEntities.concat([{ name: EMPTY }]));
  };

  const handleRemoveLegalEntities = (idx) => () => {
    setLegalEntities(legalEntities.filter((s, sidx) => idx !== sidx));
  };
  const handleEntityNameChange = (idx) => (evt) => {
    const newlegalEntities = legalEntities.map((entity, sidx) => {
      if (idx !== sidx) return entity;
      return { ...entity, name: evt.target.value };
    });
    setLegalEntities(newlegalEntities);
  };

  const renderPowerProvidersList = (selectedPowerProviders) => {
    return powerProviders.map((item, index) => (
      <div key={item.id}>
        <FormText>
          <Form.Check
            type="checkbox"
            id={"chkpp" + index}
            name={item.name}
            value={item.name}
            checked={item.isActive}
            onChange={handleCheckboxChange}
            label={item.desc}
            disabled={!isEditable}
          />
        </FormText>
      </div>
    ));
  };

  const validatePowerProviders = (providers, providerName, checked) => {
    let selectedProviders = false;
    let currentPowerProviders = [];

    currentPowerProviders = providers.filter((item) => item.isActive);
    if (currentPowerProviders.length === 1 && checked === false) {
      selectedProviders = true;
    } else if (currentPowerProviders.length === 0 && checked === true) {
      selectedProviders = false;
    } else if (currentPowerProviders.length >= 1 && checked === true) {
      selectedProviders = false;
    } else if (currentPowerProviders.length > 1 && checked === false) {
      selectedProviders = false;
    } else {
      selectedProviders = true;
    }

    if (providerName === "selectAll" && checked === false) {
      selectedProviders = true;
    }
    return selectedProviders;
  };

  const handleCheckboxChange = (e) => {
    let providerName = e.target.name;
    let checked = e.target.checked;
    let isInvalidState = false;

    isInvalidState = validatePowerProviders(
      powerProviders,
      providerName,
      checked
    );

    if (providerName === "selectAll") {
      setAllPowerProviderChecked(checked);
      setPowerProviders(
        powerProviders.map((item) => ({
          ...item,
          isActive: checked,
        }))
      );
    } else {
      setAllPowerProviderChecked(powerProviders.every((item) => item.isActive));
      setPowerProviders(
        powerProviders.map((item) =>
          item.name === providerName ? { ...item, isActive: checked } : item
        )
      );
    }
  };

  const validateLegalEntities = (Entities) => {
    const uniqueEntities = new Set(
      Entities.map((e) => Object.values(e)[0].toLowerCase())
    );
    const hasDuplicateEntities = uniqueEntities.size !== Entities.length;

    if (hasDuplicateEntities) {
      setLegalEntitiesError(true);
      return false;
    } else {
      setLegalEntitiesError(false);
      return true;
    }
  };

  const handleValidateRequest = (event) => {
    setOverlayLoading(true);
    setZipCodeError(false);

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

      setValidated(true);
      setOverlayLoading(false);
      handleAlert(ENTER_REQUIRED_INFO, DANGER);
      window.scrollTo({ top: 0, behavior: "smooth" });

      return false;
    } else if (validateLegalEntities(legalEntities) === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      setOverlayLoading(false);
      handleAlert(UNIQUE_ENTITY_NAME, DANGER);
      window.scrollTo({ top: 0, behavior: "smooth" });

      return false;
    } else if (isNaN(user.zipCode)) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      setZipCodeError(true);
      setOverlayLoading(false);
      handleAlert(ZIP_CODE_INVALID, DANGER);
      window.scrollTo({ top: 0, behavior: "smooth" });

      return false;
    } else {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false);
      let legalEntitiesValue = legalEntities.map((e) => {
        return Object.values(e)[0];
      });
      let providers = {};

      powerProviders.map((p) => (providers[p.name] = p.isActive));

      let payload = {
        first_name: user.firstName,
        last_name: user.lastName,
        phone: user.phoneNumber,
        address: user.address,
        city: user.city,
        state: user.state,
        postal_code: user.zipCode,
        legal_entities: legalEntitiesValue,
        authorized_electric_power_provider: providers,
      };
      handleRequestSubmit(payload);
    }
  };

  const handleRequestSubmit = async (payload) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    try {
      await UserService.updateProfileInfo(payload);
      setOverlayLoading(false);
      handleAlert(PROFILE_UPDATED_SUCCESSFULLY, INFO);
      setIsEditable(false);
    } catch (error) {
      console.error(ERROR_WHILE_UPDATING_PROFILE, error);
      handleAlert(ERROR_WHILE_UPDATING_PROFILE, DANGER);
      setOverlayLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const closeAlert = () => {
    setShowAlert(false);
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
  };

  const handleAlert = (message, variant) => {
    setShowAlert(true);
    setAlertMessage(message);
    setVariant(variant);
  };

  const handleRemovePhoto = () => {
    setShowRemovePicturePopup(true);
    setShowProfileDropdown(false);
  };

  const handleUploadPhoto = () => {
    setShowProfilePicturePopup(true);
    setShowProfileDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showProfileDropdown &&
        !event.target.closest(".profile-image-container")
      ) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showProfileDropdown]);

  let selectedPowerProviders = [];
  powerProviders.map((p) => {
    if (p.isActive === true) {
      selectedPowerProviders.push(EMPTY);
    }
    return true;
  });

  const alert = [];
  if (showAlert) {
    alert.push(
      <Alert
        key="messageAlert"
        showPasswordPopup={showAlert}
        variant={variant}
        closeAlert={(e) => closeAlert(e)}
        alertMessage={alertMessage}
        dismissible={true}
      />
    );
  }

  return (
    <div className="user-profile">
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Please wait..."
      />
      {alert}
      <Container className="width-850 mb-20">
        <Row className="mb-4 profile-image-row">
          <Col>
            <div className="profile-image-container">
              <div className="profile-image-placeholder">
                {userInfo.profile_pic ? (
                  <Image
                    src={userInfo.profile_pic}
                    roundedCircle
                    height={150}
                    width={150}
                    className="profile-image"
                  />
                ) : (
                  <i className="fa-solid fa-user-circle profile-image-placeholder-icon"></i>
                )}
              </div>
              <NavDropdown
                title={
                  <i className="fa-solid fa-camera profile-image-overlay-icon"></i>
                }
                className="profile-image-overlay"
                show={showProfileDropdown}
                onToggle={(isOpen) => setShowProfileDropdown(isOpen)}
              >
                <NavDropdown.Item onClick={handleUploadPhoto}>
                  <i className="fa-solid fa-upload me-2"></i>
                  Upload Photo
                </NavDropdown.Item>
                {userInfo.profile_pic && (
                  <NavDropdown.Item onClick={handleRemovePhoto}>
                    <i className="fa-solid fa-trash me-2"></i>
                    Remove
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            </div>
          </Col>
        </Row>
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleValidateRequest(e)}
        >
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="validationCustomfirstname">
              <Form.Label>First Name*</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                onChange={handleOnChange}
                required
                value={user.firstName}
                maxLength="40"
                pattern="^[\s]*[A-Za-z]+[\s]*[A-Za-z\s'-]*"
                disabled={!isEditable}
              />
              <Form.Control.Feedback type="invalid">
                {user.firstName === EMPTY
                  ? ENTER_FIRST_NAME
                  : ENTER_ONLY_LETTERS}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="validationCustomlastname">
              <Form.Label>Last Name*</Form.Label>
              <Form.Control
                onChange={handleOnChange}
                type="text"
                name="lastName"
                required
                pattern="^[\s]*[A-Za-z]+[\s]*[A-Za-z\s'-]*"
                maxLength="40"
                value={user.lastName}
                disabled={!isEditable}
              />
              <Form.Control.Feedback type="invalid">
                {user.lastName === EMPTY ? ENTER_LAST_NAME : ENTER_ONLY_LETTERS}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="validationCustomEmail">
              <Form.Label>Email*</Form.Label>
              <Form.Control
                type="email"
                name="email"
                onChange={handleOnChange}
                pattern="[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}"
                required
                value={user.email}
                disabled
              />
              <Form.Control.Feedback type="invalid">
                {user.email === EMPTY ? ENTER_MAIL : EMAIL_IS_INVALID}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="validationCustomPhone">
              <Form.Label>Mobile Phone Number*</Form.Label>
              <MaskedInput
                type="text"
                name="phoneNumber"
                className="form-control"
                required
                onChange={handleOnChange}
                mask={[
                  "(",
                  /[1-9]/,
                  /\d/,
                  /\d/,
                  ")",
                  " ",
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                value={user.phoneNumber}
                disabled
              />
              <Form.Control.Feedback type="invalid">
                {ENTER_MOBILE_NUMBER}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="validationCustomAddress">
              <Form.Label>Mailing Address*</Form.Label>
              <Form.Control
                type="text"
                onChange={handleOnChange}
                name="address"
                required
                value={user.address}
                disabled={!isEditable}
                maxLength="60"
                pattern="(.|\s)*\S(.|\s)*"
              />
              <Form.Control.Feedback type="invalid">
                {user.address === EMPTY
                  ? ENTER_MAILING_ADDRESS
                  : INVALID_MAILING_ADDRESS}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="validationCustomCity">
              <Form.Label>City*</Form.Label>
              <Form.Control
                type="text"
                name="city"
                onChange={handleOnChange}
                required
                value={user.city}
                disabled={!isEditable}
                maxLength="40"
                pattern="(.|\s)*\S(.|\s)*"
              />
              <Form.Control.Feedback type="invalid">
                {user.city === EMPTY ? ENTER_CITY : INVALID_CITY}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="5" controlId="validationCustomState">
              <Form.Label>State*</Form.Label>
              <Form.Select
                disabled={!isEditable}
                value={user.state}
                name="state"
                onChange={handleOnChange}
                required
                placeholder="Select State"
              >
                {STATES.map((item, idx) => (
                  <option value={item} key={idx}>
                    {item}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {SELECT_STATE}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="validationCustomZipCode">
              <Form.Label>Zip Code*</Form.Label>
              <Form.Control
                type="text"
                name="zipCode"
                pattern="[0-9]+"
                value={user.zipCode}
                onChange={handleOnChange}
                required
                maxLength="40"
                disabled={!isEditable}
                className={zipCodeError ? "invalidcontrol" : EMPTY}
              />
              <Form.Control.Feedback type="invalid">
                {user.zipCode === EMPTY ? ENTER_ZIP_CODE : INVALID_ZIP_CODE}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label className="mb-2 ps-0">
                Farm Operation - Legal Entities
                <p className="small mb-0 text-muted">
                  {ADD_LEGAL_ENTITIES_WITH_ACCOUNTS}
                </p>
              </Form.Label>
              <div className="w-100"></div>
              <Button
                type="button"
                className="mb-20 btn btn-primary btn-sm"
                title="Add Entities"
                onClick={handleAddLegalEntities}
                disabled={!isEditable}
              >
                Add Entities
              </Button>

              {legalEntities.map((entity, idx) => (
                <div key={idx}>
                  <Row className="mb-3 d-flex align-items-center">
                    <Form.Group as={Col} md="8">
                      <Form.Control
                        size="sm"
                        type="text"
                        maxLength="40"
                        value={entity.name}
                        onChange={handleEntityNameChange(idx)}
                        placeholder={EMPTY}
                        required
                        className={
                          legalEntitiesError ? "invalidcontrol" : EMPTY
                        }
                        disabled={!isEditable}
                        pattern="(.|\s)*\S(.|\s)*"
                      />
                      <Form.Control.Feedback type="invalid">
                        {entity.name === EMPTY
                          ? ENTER_ENTITY_NAME
                          : INVALID_ENTITY_NAME}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="2">
                      <Button
                        size="sm"
                        className="pt-1 pb-1"
                        disabled={!isEditable}
                        onClick={handleRemoveLegalEntities(idx)}
                      >
                        X
                      </Button>
                    </Form.Group>
                  </Row>
                </div>
              ))}
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>
                <strong>Authorized Electric Power Provider</strong>
              </Form.Label>
              <Form.Label className="mt-1">
                I hereby give the Electric Power Providers selected below
                permission to release my electric data to Twin Platte NRD &
                GiSC. This permission includes the release of past, present, and
                future electric data so as to facilitate providing irrigation
                records for previous, present, and future growing seasons. This
                permission only includes data releases so long as this
                authorization for the Authorized Electric Power Provider remains
                in effect.
              </Form.Label>
            </Form.Group>

            <Form.Group as={Col} md="8">
              <FormText className="ps-15">
                <Form.Check
                  type="checkbox"
                  name="selectAll"
                  disabled={!isEditable}
                  id="selectAll"
                  checked={allPowerProviderChecked}
                  feedback={SELECT_ATLEAST_ONE_PROVIDER}
                  onChange={handleCheckboxChange}
                  label="Select All"
                />
                {renderPowerProvidersList(selectedPowerProviders)}
              </FormText>
            </Form.Group>
          </Row>
          <Form.Group as={Col} md="12" className="mt-2">
            {isEditable ? (
              <Button type="submit">Update</Button>
            ) : (
              <Button
                type="button"
                disabled={user.email === EMPTY ? true : false}
                onClick={handleEditUserProfile}
              >
                Edit
              </Button>
            )}
            {EMPTY}{" "}
            <Button
              type="button"
              disabled={isEditable ? false : true}
              onClick={handleCancelUserProfile}
            >
              Cancel
            </Button>
          </Form.Group>
        </Form>
      </Container>
      <UploadPicturePopup
        show={showProfilePicturePopup}
        onClose={() => setShowProfilePicturePopup(false)}
        handleAlert={handleAlert}
      />
      <RemovePicturePopup
        show={showRemovePicturePopup}
        onClose={() => setShowRemovePicturePopup(false)}
        handleAlert={handleAlert}
      />
    </div>
  );
}

export default UserProfile;
